/* ************************************************************************** */
/*                                Dependencies                                */
/* ************************************************************************** */

// UI lib components
import { Textarea } from '@mantine/core';

// Types
import { SupportTextareaProps } from './type';

// Style
import * as classes from './styles/index.css';

// Constants
const VALUE_MAX_LENGTH = 3000;

/* ************************************************************************** */
/*                                  Component                                 */
/* ************************************************************************** */

function SupportTextarea({ ...props }: SupportTextareaProps) {
  /* ******************************** RENDERING ******************************* */
  return (
    <Textarea
      classNames={{
        input: classes.textareaInput,
      }}
      maxLength={VALUE_MAX_LENGTH}
      {...props}
    />
  );
}

export default SupportTextarea;
